<template>
  <div class="row container-fluid">
    <div class="d-none d-sm-block col-sm-2 col-lg-3"></div>

    <div class="col-12 col-sm-8 col-lg-6 px-2 px-sm-0">

      <!-- PRODUCTO OK -->
      <div v-if="resProducto === 'OK'" class="compra-pronostico">

        <div v-if="!pagoCompletado">

          <PronosticoCabecera
            :producto="producto"
            :tieneExpiracion="tieneExpiracion"
            :textoCuentaRegresiva="textoCuentaRegresiva"
            :descuentoDisponible="descuentoDisponible"
            :descuentoOK="descuentoOK"
            :bloquearUI="bloquearUI"
            :pagoCompletado="pagoCompletado"
            :codigoDescuento="codigoDescuento"
            :mensajeDescuento="mensajeDescuento"
            :precioNormalMostrado="precioNormalMostrado"
            :precioFinalMostrado="precioFinalMostrado"
            :ahorroMostrado="ahorroMostrado"
            :porcentajeAhorro="porcentajeAhorro"
            :simboloMoneda="simboloMoneda"
            :diasGracia="Number(producto?.dias_gracia) || 0"
            @update:codigoDescuento="codigoDescuento = $event"
            @validar-descuento="validarDescuento"
          />

          <!-- LOGGED IN -->
          <PronosticoFormLoggedIn
            v-if="loggedIn"
            :key="publicKey"
            :emailLogged="emailLogged"
            :clientSecret="clientSecret"
            :publicKey="publicKey"
            :bloquearUI="bloquearUI"
            :pagoCompletado="pagoCompletado"
            :mostrarUrl="mostrarUrl"
            :producto="producto"
            :descuentoOK="descuentoOK"
            :precioNormalMostrado="precioNormalMostrado"
            :precioFinalMostrado="precioFinalMostrado"
            :rateMoneda="rateMoneda"
            :simboloMoneda="simboloMoneda"
            :idiomaActual="idiomaActual"
            :stripeMode="stripeMode"
            :referenciaPedido="refPedido"
            :diasGracia="diasGracia"
            :usePaymentElement="usePaymentElement"
            :pais="paisCompra"
            :paises="paises"
            :esSuscripcion="esSuscripcion"
            @cerrar-componente="mostrarEnlace"
            @pais-seleccionado="onPaisLogueadoSeleccionado"
          />

          <!-- NOT LOGGED IN -->
          <PronosticoCompraDirecta
            ref="compraDirectaRef"
            v-if="!loggedIn && compraDirecta && !esSuscripcion"
            :clientSecret="clientSecret"
            :publicKey="publicKey"
            :bloquearUI="bloquearUI"
            :pagoCompletado="pagoCompletado"
            :descuentoOK="descuentoOK"
            :precioNormalMostrado="precioNormalMostrado"
            :precioFinalMostrado="precioFinalMostrado"
            :rateMoneda="rateMoneda"
            :simboloMoneda="simboloMoneda"
            :idiomaActual="idiomaActual"
            :producto="producto"
            :paises="paises"
            :usePaymentElement="usePaymentElement"
            @solicitar-pago="onSolicitarPagoDirecto"
            @cancelar="cancelarCompraDirecta"
            @cerrar-componente="mostrarEnlace"
          />

          <!-- SUSCRIPCIÓN: registro inline -->
          <div v-if="!loggedIn && !compraDirecta && esSuscripcion" class="mt-4">
            <PronosticoRegistroInline
              :bloquearUI="bloquearUI"
              :paises="paises"
              @registrado="onRegistroRapido"
            />
          </div>

          <!-- VENTA ÚNICA: flujo normal -->
          <div
            v-if="!loggedIn && !compraDirecta && !esSuscripcion"
            style="max-width:400px;margin: 3rem auto;"
            class="label-input2"
          >
            <template v-if="true">
            <div class="botones-pronostico">
              <QBtn type="button" variant="tipster" class="btn-pronostico" :disabled="bloquearUI" @click.prevent="activarCompraDirecta">
                💳 {{ $t('pronostico.pay') }}
              </QBtn>
              <button
                type="button"
                class="btn btn-outline-secondary btn-pronostico mt-2"
                @click.prevent="$store.commit('abrirLoginModal')"
                :disabled="bloquearUI"
              >
                <i class="fa fa-sign-in me-1"></i> {{ $t('pronostico.loginToPayLabel') || 'Ya tengo cuenta' }}
              </button>
            </div>

            <div v-if="esUsuario || permitirRegistro || validarCodigo" class="mt-4">
              <label>{{ $t('pronostico.phone') }}</label>
              <vue-tel-input
                v-model="telefonoUnlogged"
                :only-countries="['es','fr','pt','de','nl','ie','gb','mx','ar','cl','br']"
                :valid-character-only="true"
                :auto-format="false"
                :inputoptions="{ showDialCode: true, placeholder: 'E164' }"
                @input="checkValidPhoneNumber2"
                @country-changed="handleCountryChange"
                class="bordes"
              />
              <div v-if="!isValidPhoneNumber" class="error-feedback text-xs text-danger mb-4 mt-2">
                {{ $t('pronostico.phoneInvalid') }}
              </div>
            </div>

            <div class="mt-3 mb-2" v-if="esUsuario">
              <soft-field
                id="password"
                v-model="passwordUnlogged"
                type="password"
                :label="$t('pronostico.password')"
                name="password"
                class="mb-2 label-input2 bordes"
                :useLabel="true"
              />
              <p
                class="mb-0"
                @click="recordarClave"
                style="cursor:pointer;text-align:left;font-size:1.1rem;"
              >
                {{ $t('pronostico.sendPassword') }}
              </p>
              <QBtn type="button" variant="tipster" class="float-end mt-4" @click.prevent="validarSesionCliente">
                <span class="text-xs">{{ $t('pronostico.login') }} &nbsp;<i class="fa fa-chevron-right"></i></span>
              </QBtn>
            </div>

            <div class="mb-2 mt-4" v-if="permitirRegistro">
              <soft-field
                id="nombre"
                v-model="nameUnlogged"
                type="text"
                :placeholder="$t('pronostico.namePlaceholder')"
                name="nombre"
                class="mb-2 label-input2 bordes"
                largo="80"
                :label="$t('pronostico.name')"
                :useLabel="true"
              />
              <div class="mt-4">
                <QToggle v-model="indacepto" />
                <label class="label-switch">{{ $t('pronostico.acceptData') }}</label>
              </div>
              <QBtn type="button" variant="tipster" class="float-end mt-4" @click.prevent="registrarCliente">
                <span class="text-xs">{{ $t('pronostico.register') }} &nbsp;<i class="fa fa-chevron-right"></i></span>
              </QBtn>
            </div>

            <div class="mb-2 mt-4" v-if="validarCodigo">
              <soft-field
                id="codigo"
                v-model="codeUnlogged"
                type="number"
                :placeholder="$t('pronostico.codePlaceholder')"
                name="codigo"
                class="mb-2 label-input3 bordes"
                largo="6"
                :label="$t('pronostico.telegramCode')"
                :useLabel="true"
              />
              <QBtn type="button" variant="tipster" class="float-end mt-4" @click.prevent="confirmarCodigo">
                <span class="text-xs">{{ $t('pronostico.confirm') }} &nbsp;<i class="fa fa-chevron-right"></i></span>
              </QBtn>
            </div>

            </template><!-- /venta_unica -->
          </div>
        </div>

        <PronosticoPagoCompletado v-if="pagoCompletado" :key="pagoTransactionId" :enlaceGenerado="enlaceGenerado" :importe="precioFinal" :moneda="monedaSel" :transactionId="pagoTransactionId" :itemName="producto ? producto.nombre : ''" />
      </div>

      <PronosticoServicioNoDisponible v-if="resProducto === 'NOK'" :errorProducto="errorProducto" />

      <ModalRegistroEmail v-if="showModalRegistro" @cerrar="showModalRegistro = false" />
    </div>

    <div class="col-1 col-sm-2 col-lg-3"></div>
  </div>
</template>



<script>
import SoftField from "@/components/SoftField.vue";
import showSwal from "/src/mixins/showSwal.js";
import { isValidPhoneNumber } from 'libphonenumber-js';
import PronosticoCabecera from "@/views/components/pronostico/PronosticoCabecera.vue";
import PronosticoRegistroInline from "@/views/components/pronostico/PronosticoRegistroInline.vue";
import PronosticoFormLoggedIn from "@/views/components/pronostico/PronosticoFormLoggedIn.vue";
import PronosticoCompraDirecta from "@/views/components/pronostico/PronosticoCompraDirecta.vue";
import PronosticoPagoCompletado from "@/views/components/pronostico/PronosticoPagoCompletado.vue";
import PronosticoServicioNoDisponible from "@/views/components/pronostico/PronosticoServicioNoDisponible.vue";
import ModalRegistroEmail from "@/views/components/pronostico/ModalRegistroEmail.vue";

export default {
  name: "Pronostico",
  props: ['uuid'],
  components: {
    SoftField,
    PronosticoCabecera,
    PronosticoRegistroInline,
    PronosticoFormLoggedIn,
    PronosticoCompraDirecta,
    PronosticoPagoCompletado,
    PronosticoServicioNoDisponible,
    ModalRegistroEmail,
  },
  data() {
    return {
      esperandoConfirmacion: false,
      codigoDescuento: "",
      mensajeDescuento: "",
      descuentoOK: false,
      descuentoDisponible: false,
      precioFinal: 0,
      pagoCompletado: false,
      pagoTransactionId: "",
      enlaceGenerado: "",
      bloquearUI: false,
      loading: false,
      showError: false,
      resProducto: '',
      errorProducto: '',
      emailLogged: '',
      telefonoLogged: '',
      telefonoUnlogged: '',
      nameUnlogged: '',
      passwordUnlogged: '',
      codeUnlogged: '',
      esUsuario: false,
      indacepto: false,
      permitirRegistro: false,
      validarCodigo: false,
      clientSecret: '',
      mostrarUrl: '',
      stripeMode: 'payment',
      diasGracia: 0,
      usePaymentElement: false,
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      producto: {id: 0, nombre: '', precio: 0, tipsterid: 0, tipstername: ''},
      compraDirecta: false,
      showModalRegistro: false,
      correoCompra: '',
      paisCompra: '',
      refPedido: '',
      isValidPhoneNumber: true,
      paises: [],
      monedaSel: "EUR",
      simbolos: { EUR: "€", USD: "$", GBP: "£", BRL: "R$", MXN: "$", ARS: "$", CLP: "$", COP: "$" },
      expiresAt: null,
      countdownMs: 0,
      countdownTimer: null,
    };
  },
  computed: {
    idiomaActual() {
      return this.$i18n.locale;
    },
    ahorro() {
      const normal = Number(this.producto?.precio || 0);
      const finalP = Number(this.precioFinal || 0);
      const diff = normal - finalP;
      return diff > 0 ? diff : 0;
    },
    porcentajeAhorro() {
      const normal = Number(this.producto?.precio || 0);
      const a = Number(this.ahorro || 0);
      if (normal <= 0) return 0;
      return (a / normal) * 100;
    },
    tieneExpiracion() {
      return !!this.expiresAt && this.countdownMs > 0;
    },
    simboloMoneda() {
      return this.simbolos?.[this.monedaSel] || this.monedaSel;
    },
    rateMoneda() {
      return 1;
    },
    precioFinalMostrado() {
      return Number(this.precioFinal || 0) * this.rateMoneda;
    },
    precioNormalMostrado() {
      return Number(this.producto?.precio || 0) * this.rateMoneda;
    },
    ahorroMostrado() {
      return Number(this.ahorro || 0) * this.rateMoneda;
    },
    textoCuentaRegresiva() {
      const ms = Math.max(0, this.countdownMs);
      const totalSec = Math.floor(ms / 1000);

      const d = Math.floor(totalSec / 86400);
      const h = Math.floor((totalSec % 86400) / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      const s = totalSec % 60;

      const pad = (n) => String(n).padStart(2, "0");

      if (d > 0) {
        return this.$t("pronostico.countdownDays", {
          d,
          h: pad(h),
          m: pad(m),
          s: pad(s)
        });
      }

      return this.$t("pronostico.countdownHours", {
        h: pad(h),
        m: pad(m),
        s: pad(s)
      });
    },
    loggedIn() {
      return this.$store.getters["auth/loggedIn"];
    },
    esSuscripcion() {
      return this.producto?.tipo_venta && this.producto.tipo_venta !== 'venta_unica';
    },
  },

  watch: {
    loggedIn(newVal, oldVal) {
      if (newVal && !oldVal && this.resProducto === 'OK') {
        if (!this.emailLogged) {
          this.emailLogged = this.$store.state.emailLogueado || '';
        }
        this.generarPedido();
      }
    },
    '$store.state.emailLogueado'(email) {
      if (email && this.resProducto === 'OK' && this.loggedIn) {
        this.emailLogged = email;
        this.mostrarUrl = "";
        if (!this.clientSecret && !this.bloquearUI) this.generarPedido();
      }
    },
  },

  async created() {
    this.pagoCompletado = false;
    this.enlaceGenerado = "";
    this.mostrarUrl = "";
    this.clientSecret = "";
    this.refPedido = "";
    this.stripeMode = "payment";
    this.diasGracia = 0;
    this.bloquearUI = false;
    this.esperandoConfirmacion = false;

    this.codigoDescuento = "";
    this.mensajeDescuento = "";
    this.descuentoOK = false;

    // Cargar países de venta desde la API (configurables por superadmin)
    try {
      const r = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/v2/public/paises-venta`);
      const data = await r.json();
      if (Array.isArray(data?.paises) && data.paises.length) {
        this.paises = data.paises;
      }
    } catch (_) {
      // fallback silencioso — paises queda vacío, el select no muestra nada
    }

    localStorage.removeItem("mostrarUrl");
    localStorage.removeItem("refPedido");
    let response = null;

    try {
      response = await this.$store.dispatch("auth/consultaProducto", { uuid: this.uuid });
      this.resProducto = response?.res || 'NOK';
    } catch (error) {
      console.error("❌ Error en consultaProducto:", error);
      this.resProducto = 'NOK';
      this.errorProducto = "No se pudo cargar el producto.";
      return;
    }

    if (response.res === 'OK') {
      this.producto = response.producto ?? {};
      this.monedaSel = (this.producto.moneda || 'EUR').toUpperCase();
      this.usePaymentElement = response.use_payment_element === true;

      const idiomaInicial = this.resolverIdiomaInicial(this.producto);
      this.$i18n.locale = idiomaInicial;
      localStorage.setItem("quanty_lang", idiomaInicial);

      const rawExpire =
        this.producto?.expires_at ??
        this.producto?.fecha_expiracion ??
        this.producto?.fecha_fin ??
        this.producto?.expira_at ??
        null;

      const d = this.parseExpireDate(rawExpire);
      if (d) {
        this.expiresAt = d;
        this.iniciarCountdown();
      }
      if (this.producto?.precio_mostrar == null && this.producto?.precio_mostrado != null) {
        this.producto.precio_mostrar = this.producto.precio_mostrado;
      }
      this.descuentoDisponible = !!response.descuentoDisponible;
      this.precioFinal = Number(this.producto?.precio_mostrar ?? this.producto?.precio_mostrado ?? this.producto?.precio) || 0;
      if (!this.descuentoDisponible) {
        this.codigoDescuento = "";
        this.mensajeDescuento = "";
        this.descuentoOK = false;
      }
    } else {
      const idiomaInicial = this.resolverIdiomaInicial(null);
      this.$i18n.locale = idiomaInicial;
      localStorage.setItem("quanty_lang", idiomaInicial);

      this.errorProducto = response.mensaje ?? '';
      this.precioFinal = 0;
    }

    const ra = this.producto?.rebaja_aplica;
    this.producto.rebaja_aplica =
      ra === true || ra === 1 || ra === "1" || ra === "true";

    if (this.loggedIn) {
      this.emailLogged = localStorage.getItem("usuarioEmail") || "";
      this.telefonoLogged = localStorage.getItem("usuarioTelefono") || "";
      this.mostrarUrl = "";
      this.passLogged = '';
      this.generarPedido();
    } else {
      this.telefonoUnlogged = '';
      this.nameUnlogged = '';
      this.passwordUnlogged = '';
    }
  },
  beforeMount() {
    this.$store.commit('setShowNavbar', true);
    this.$store.commit('setShowSidenav', false);
    this.$store.commit('setShowFooter', true);
  },
  beforeUnmount() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  },
  methods: {
    onRegistroRapido({ email, pais } = {}) {
      this.emailLogged = email || '';
      this.$store.commit('setEmailLogueado', email || '');
      if (pais) this.paisCompra = pais;
      this.generarPedido();
    },

    resolverIdiomaInicial(producto = null) {
      const soportados = ["es", "en", "pt", "fr"];

      // El idioma del producto siempre tiene prioridad
      const objetivo = String(producto?.publico_objetivo || "")
        .toLowerCase()
        .trim();

      if (objetivo && soportados.includes(objetivo)) {
        return objetivo;
      }

      // Sin publico_objetivo: usar preferencia guardada o idioma del navegador
      const guardado = localStorage.getItem("quanty_lang");
      if (guardado && soportados.includes(guardado)) {
        return guardado;
      }

      const navLang =
        navigator.language ||
        navigator.userLanguage ||
        (Array.isArray(navigator.languages) ? navigator.languages[0] : "") ||
        "es";

      const base = String(navLang).toLowerCase().split("-")[0];

      return soportados.includes(base) ? base : "es";
    },
    cambiarIdioma(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("quanty_lang", lang);
    },
    onPaisLogueadoSeleccionado(pais) {
      this.paisCompra = pais;
      this.generarPedido();
    },

    onSolicitarPagoDirecto({ correo, pais }) {
      this.correoCompra = correo;
      this.paisCompra = pais;
      this.continuarPagoDirecto();
    },

    async continuarPagoDirecto() {
      try {
        await this.generarPedido();
      } catch (error) {
        console.error("❌ Error en continuarPagoDirecto:", error);
        this.loading = false;
        this.bloquearUI = false;
        showSwal.methods.showSwal({
          type: "error",
          message: "Se produjo un error al iniciar el pago.",
          width: 550,
        });
      }
    },

    async validarDescuento() {
      if (!this.descuentoDisponible) {
        this.mensajeDescuento = this.$t("pronostico.couponNoAvailable");
        this.descuentoOK = false;
        return;
      }

      if (!this.codigoDescuento) {
        this.mensajeDescuento = this.$t("pronostico.couponEnterCode");
        this.descuentoOK = false;
        return;
      }

      try {
        this.codigoDescuento = this.codigoDescuento.trim().toUpperCase();
        const resp = await this.$store.dispatch("auth/validarDescuento", {
          codigo: this.codigoDescuento,
          producto: this.producto.id
        });

        if (resp.res === "OK") {
          this.descuentoOK = true;
          this.mensajeDescuento = this.$t("pronostico.couponAppliedOk");
          this.precioFinal = Number(resp.precioFinal) || Number(this.producto.precio);
        } else {
          this.descuentoOK = false;
          this.mensajeDescuento = resp.mensaje || this.$t("pronostico.couponInvalid");
          this.precioFinal = Number(this.producto.precio_mostrar ?? this.producto.precio) || 0;
        }
      } catch (e) {
        this.descuentoOK = false;
        this.mensajeDescuento = this.$t("pronostico.couponCheckError");
        this.precioFinal = Number(this.producto.precio_mostrar ?? this.producto.precio) || 0;
      }
    },

    async validarTelefonoCliente() {
      if (!this.isValidPhoneNumber) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalPhoneInvalid"),
          width: 450,
        });
      }
      else {
        const response = await this.$store.dispatch("auth/validaTelefonoUsuario", { telefono: this.telefonoUnlogged.replace(/\s+/g, ''), uuid: this.uuid });
        if (response.res=='OK') {
          if (response.existe) {
            this.esUsuario = true;
            this.permitirRegistro = false;
            this.validarCodigo = false;
          }
          else {
            this.esUsuario = false;
            this.permitirRegistro = true;
            this.validarCodigo = false;
          }
        }
        else {
          showSwal.methods.showSwal({
            type: "error",
            message: response.mensaje,
            width: 450,
          });
        }
      }
    },

    async registrarCliente() {
      if (!this.isValidPhoneNumber) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalPhoneInvalid"),
        });
      }
      else if (this.nameUnlogged.length<9) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalNameLength"),
          width: 600,
        });
      }
      else if (!this.indacepto) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalAcceptConditions"),
          width: 600,
        });
      }
      else{
        try {
          var usuario = {
            telefono: this.telefonoUnlogged.replace(/\s+/g, ''),
            name: this.nameUnlogged
          };

          this.loading = false;
          const resp = await this.$store.dispatch("auth/register", usuario);
          if (resp.res=='OK') {
            showSwal.methods.showSwal({
              type: "success",
              message: this.$t("pronostico.swalTelegramCode"),
              width: 600,
            });
            this.permitirRegistro = false;
            this.validarCodigo = true;
          }
          else {
            showSwal.methods.showSwal({
              type: "error",
              message: resp.mensaje,
              width: 500
            });
          }
        } catch (error) {
          this.loading = false;
          showSwal.methods.showSwal({
            type: "error",
            message: this.$t("pronostico.swalGenericError"),
            width: 500,
          });
        }
      }
    },

    async confirmarCodigo() {
      if (!this.isValidPhoneNumber) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalPhoneInvalid"),
        });
      }
      else if (this.codeUnlogged.length!=6) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalCodeSixDigits"),
          width: 600,
        });
      }
      else{
        try {
          var usuario = {
            telefono: this.telefonoUnlogged.replace(/\s+/g, ''),
            codigo: this.codeUnlogged
          };

          this.loading = false;
          const resp = await this.$store.dispatch("auth/validaCodigo", usuario);
          if (resp.res=='OK') {
            showSwal.methods.showSwal({
              type: "success",
              message: this.$t("pronostico.swalUserRegistered"),
              width: 600,
            });
            this.validarCodigo = false;
            localStorage.setItem("usuarioNombre",this.nameUnlogged);
            localStorage.setItem("usuarioTelefono",this.telefonoUnlogged.replace(/\s+/g, ''));
            localStorage.setItem("usuarioRolId",3);
            localStorage.setItem("usuarioTipsterId",0);
            this.telefonoLogged = this.telefonoUnlogged.replace(/\s+/g, '');

            this.generarPedido();
          }
          else {
            showSwal.methods.showSwal({
              type: "error",
              message: resp.mensaje,
              width: 500
            });
          }
        } catch (error) {
          this.loading = false;
          showSwal.methods.showSwal({
            type: "error",
            message: this.$t("pronostico.swalGenericError"),
            width: 500,
          });
        }
      }
    },

    async validarSesionCliente() {
      this.loading = true;
      var usuario = {
        usuario: this.telefonoUnlogged,
        password: this.passwordUnlogged,
      };
      try {
        await this.$store.dispatch("auth/login", usuario);
        localStorage.setItem("usuarioNombre",this.nameUnlogged);
        localStorage.setItem("usuarioTelefono",this.telefonoUnlogged.replace(/\s+/g, ''));
        localStorage.setItem("usuarioRolId",3);
        localStorage.setItem("usuarioTipsterId",0);
        this.telefonoLogged = this.telefonoUnlogged.replace(/\s+/g, '');

        this.generarPedido();
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalInvalidAccess"),
        });
      }
      this.loading = false;
    },


    async generarPedido() {
      if (this.loggedIn && !this.paisCompra) return;
      if (this.bloquearUI || this.esperandoConfirmacion || this.clientSecret) return;
      this.loading = true;
      this.bloquearUI = true;
      const identificador = this.loggedIn
        ? ''
        : this.correoCompra?.trim() || '';

      const parseCookie = (name) => document.cookie.split(';')
        .map(c => c.trim())
        .find(c => c.startsWith(name + '='))
        ?.split('=')[1] || null;
      let qtySid = parseCookie('qty_sid');
      const qtyPlId = parseCookie('qty_pl_id');

      // GA4: client_id desde cookie _ga (formato GA1.1.XXXXXXXXXX.XXXXXXXXXX → "XXXXXXXXXX.XXXXXXXXXX")
      const gaRaw = parseCookie('_ga');
      const gaParts = gaRaw ? gaRaw.split('.') : [];
      const gaClientId = gaParts.length >= 4 ? `${gaParts[2]}.${gaParts[3]}` : null;
      // GA4: session_id desde cookie _ga_Z58BX5RN2W (formato GS2.1.s<session_id>$o...)
      const gaSessionRaw = parseCookie('_ga_Z58BX5RN2W');
      const gaSessionParts = gaSessionRaw ? gaSessionRaw.split('.') : [];
      const gaSessionRawPart = gaSessionParts.length >= 3 ? gaSessionParts[2] : '';
      const gaSessionId = gaSessionRawPart.startsWith('s')
        ? gaSessionRawPart.slice(1).split('$')[0]
        : (gaSessionRawPart || null);
      // Consentimiento analítica
      let gaConsent = false;
      try { gaConsent = JSON.parse(localStorage.getItem('quanty_consent_v1') || '{}').analytics === true; } catch (_) { /* ignore */ }

      // Si no hay qty_sid pero llegó fbclid por URL (ej: desde PasarelaPublica), persistirlo en cookie
      if (!qtySid) {
        const urlParams = new URLSearchParams(window.location.search);
        const fbclidUrl = urlParams.get('fbclid');
        if (fbclidUrl) {
          const exp = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `qty_fbclid=${encodeURIComponent(fbclidUrl)};expires=${exp};path=/;SameSite=Lax`;
        }
      }

      var pedido = {
        usuario: identificador,
        producto: this.producto.id,
        descuento: this.descuentoOK ? (this.codigoDescuento || null) : null,
        precioFinal: Number(this.precioFinal),
        pais: this.paisCompra || 'ES',
        landing_session_uuid: qtySid,
        producto_landing_id: qtyPlId ? Number(qtyPlId) : null,
        fbclid_fallback: !qtySid ? (parseCookie('qty_fbclid') || null) : null,
        fbp: parseCookie('_fbp') || null,
        fbc: parseCookie('_fbc') || null,
        ga_client_id:  gaClientId,
        ga_session_id: gaSessionId,
        ga_consent:    gaConsent,
      };

      try {
        const response = await this.$store.dispatch("auth/generarPedido", pedido);
        if (response.res === 'OK') {
          if (!response.clientSecret || typeof response.clientSecret !== "string") {
            showSwal.methods.showSwal({
              type: "error",
              message: "No se recibió un clientSecret válido desde el servidor.",
              width: 550,
            });
            this.loading = false;
            this.bloquearUI = false;
            return;
          }

          if (!this.publicKey || typeof this.publicKey !== "string") {
            showSwal.methods.showSwal({
              type: "error",
              message: "No se encontró la clave pública de Stripe.",
              width: 550,
            });
            this.loading = false;
            this.bloquearUI = false;
            return;
          }

          this.clientSecret = response.clientSecret;
          this.refPedido = response.referencia;
          // Usar la clave pública del tipster si vino en la respuesta (para evitar mismatch de cuentas Stripe)
          if (response.publicKey && typeof response.publicKey === 'string') {
            this.publicKey = response.publicKey;
          }
          this.stripeMode = response.es_trial ? 'setup' : 'payment';
          this.diasGracia = response.es_trial ? (Number(response.dias_gracia) || 0) : 0;
          localStorage.setItem("refPedido", this.refPedido);
          setTimeout(() => {
            const card = document.querySelector('.card-compra-directa');
            if (card) card.scrollIntoView({ behavior: 'smooth', block: 'end' });
          }, 600);

        } else {
          if (this.loggedIn) {
            showSwal.methods.showSwal({
              type: "error",
              message: response.mensaje || this.$t("pronostico.swalGenericError"),
            });
          } else {
            console.warn("⚠️ Pedido no generado (compra directa).", response.mensaje);
          }
        }
      } catch (error) {
        const mensajeApi = error?.response?.data?.mensaje;
        if (this.loggedIn) {
          showSwal.methods.showSwal({
            type: "error",
            message: mensajeApi || this.$t("pronostico.swalInvalidAccess"),
          });
        } else {
          console.warn("⚠️ Error en generarPedido (compra directa).", error);
        }
      }

      this.loading = false;
      this.bloquearUI = false;
    },


    async mostrarEnlace(resultado, url, paymentId = null, clientSecret = null) {
      if (this.esperandoConfirmacion) return;

      if (resultado !== "OK") {
        this.pagoCompletado = false;
        this.enlaceGenerado = "";
        this.mostrarUrl = "";
        return;
      }

      // Si confirmarPagado ya devolvió el enlace, lo usamos directamente
      if (url) {
        this.enlaceGenerado = url;
        this.mostrarUrl = url;
        this.pagoCompletado = true;
        this.pagoTransactionId = this.refPedido || paymentId || "";
        this.compraDirecta = false;
        return;
      }

      let pid = paymentId;
      if (!pid && (clientSecret || this.clientSecret)) {
        const cs = String(clientSecret || this.clientSecret);
        pid = cs.split("_secret_")[0];
      }

      await this.esperarConfirmacionPago(pid);
    },

    async esperarConfirmacionPago(paymentId) {
      if (!paymentId) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalNoPaymentConfirmation"),
          width: 650,
        });
        return;
      }
      this.esperandoConfirmacion = true;
      this.bloquearUI = true;

      const ref = this.refPedido || localStorage.getItem("refPedido") || "";

      const maxIntentos = 15;
      const esperaMs = 2000;

      for (let i = 0; i < maxIntentos; i++) {
        try {
          const resp = await this.$store.dispatch("auth/estadoPedidoPago", {
            paymentId,
            refPedido: ref,
          });

          if (resp?.res === "OK" && resp?.pagado) {
            const enlace = resp.enlace;

            this.enlaceGenerado = enlace;
            this.mostrarUrl = enlace;

            this.pagoCompletado = true;
            this.pagoTransactionId = this.refPedido || paymentId || "";
            this.compraDirecta = false;

            this.bloquearUI = false;
            this.esperandoConfirmacion = false;
            return;
          }
        } catch (e) {
          // seguimos intentando
        }

        await new Promise(r => setTimeout(r, esperaMs));
      }

      this.bloquearUI = false;
      this.esperandoConfirmacion = false;
      showSwal.methods.showSwal({
        type: "warning",
        message: this.$t("pronostico.swalPaymentPending"),
        width: 650,
      });
    },


    redirigirPedidos() {
      this.$router.push("/pedidos");
    },

    checkValidPhoneNumber() {
      this.isValidPhoneNumber = isValidPhoneNumber(this.telefonoLogged || '');
    },

    checkValidPhoneNumber2() {
      this.isValidPhoneNumber = isValidPhoneNumber(this.telefonoUnlogged || '');
    },

    handleCountryChange(countryData) {
      const prefijo = '+' + countryData.dialCode;
      if (this.telefonoUnlogged.substr(0,prefijo.length)!==prefijo) {
        this.telefonoUnlogged = prefijo;
      }
      if (this.telefonoLogged.substr(0,prefijo.length)!==prefijo) {
        this.telefonoLogged = prefijo;
      }
    },

    async recordarClave() {
      this.loading = true;
      var pedido = {
        usuario: this.telefonoUnlogged.replace(/\s+/g, ''),
      };
      try {
        const response = await this.$store.dispatch("auth/recordarCodigo", pedido);
        if (response.res=='OK') {
          showSwal.methods.showSwal({
            type: "success",
            message: this.$t("pronostico.swalPasswordSent"),
            width: 500
          });
        }
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: this.$t("pronostico.swalGenericError"),
        });
      }
    },

    mostrarLogin() {
      this.esUsuario = true;
      this.permitirRegistro = false;
      this.validarCodigo = false;
      this.compraDirecta = false;
    },

    mostrarRegistro() {
      this.esUsuario = false;
      this.permitirRegistro = true;
      this.validarCodigo = false;
      this.compraDirecta = false;
    },

    activarCompraDirecta() {
      try {
        this.compraDirecta = true;
        this.esUsuario = false;
        this.permitirRegistro = false;
        this.validarCodigo = false;
        this.$nextTick(() => {
          setTimeout(() => {
            const el = this.$refs.compraDirectaRef?.$el ?? this.$el?.querySelector('.card-compra-directa');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 200);
        });
      } catch (error) {
        console.error("❌ Error en activarCompraDirecta:", error);
        this.compraDirecta = false;
        showSwal.methods.showSwal({
          type: "error",
          message: "Se produjo un error al abrir la compra directa.",
          width: 550,
        });
      }
    },

    cancelarCompraDirecta() {
      this.bloquearUI = false;
      this.clientSecret = "";
      this.refPedido = "";
      this.stripeMode = "payment";
      this.diasGracia = 0;
      this.mostrarUrl = "";
      this.compraDirecta = false;
    },

    parseExpireDate(raw) {
      if (!raw) return null;

      if (typeof raw === "string" && raw.includes(" ") && !raw.includes("T")) {
        raw = raw.replace(" ", "T");
      }

      const d = new Date(raw);
      return isNaN(d.getTime()) ? null : d;
    },

    iniciarCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);

      const tick = () => {
        const now = Date.now();
        const end = this.expiresAt?.getTime?.() || 0;
        this.countdownMs = Math.max(0, end - now);

        if (this.countdownMs <= 0 && this.countdownTimer) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      };

      tick();
      this.countdownTimer = setInterval(tick, 1000);
    },

  },
};


</script>
<style>
.cabecera-pronostico{
  text-align: center;
  max-width: 520px;
  margin: 0 auto 0.75rem auto;
}

.compra-pronostico {
  display: flex;
  justify-content: center;
  align-items: center;

  /* ✅ NO altura fija: que crezca si hace falta */
  min-height: calc(100vh - 140px);
  height: auto;

  /* ✅ espacio para que no lo tape el footer / barras móviles */
  padding: 1.5rem 0 7rem;

  /* ✅ por si algún contenedor padre limita */
  overflow: visible;
}

.compra-pronostico > div {
  width: 100%;
}

.botones-pronostico {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
  margin-top: 3rem;
  font-family: var(--q-font-ui);
}

/* 🔘 Estilo base de cada botón */
.btn-opcion {
  width: 300px;
  height: 65px;
  border: none;
  font-family: var(--q-font-ui);
  font-weight: 700;
  font-size: 2.5rem; /* ~20px */
  color: #fff;
  border-radius: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.25s ease;
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.btn-opcion:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.25);
  filter: brightness(1.1);
}

/* 💙 Iniciar sesión */
.btn-opcion.azul {
  background: linear-gradient(135deg, #0044cc, #007BFF);
  color: #fff;
}

/* 💚 Registrarse */
.btn-opcion.verde {
  background: linear-gradient(135deg, #0bab64, #3bb78f);
  color: #fff;
}

/* 💛 Proceder al pago */
.btn-opcion.naranja {
  background: linear-gradient(135deg, #ffb347, #ffcc33);
  color: #fff;
}

.card-compra-directa {
  background: var(--q-card);
  border-radius: 20px;
  border: 1px solid var(--q-border);
  text-align: center;
}

.titulo-compra {
  font-family: var(--q-font-ui);
  font-size: 1.7rem;
  color: var(--q-text);
}

.subtitulo-compra {
  font-family: var(--q-font-ui);
  font-size: 1.05rem;
  color: var(--q-muted);
}

.stripe-container {
  background-color: var(--q-card-alt);
  border-radius: 16px;
  border: 1px solid var(--q-border);
  padding: 1.5rem;
}

.btn-volver {
  background: linear-gradient(135deg, #007BFF, #00B4D8);
  color: #fff;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 0.7rem 2rem;
  transition: all 0.25s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-volver:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  filter: brightness(1.1);
}
.btn-pronostico {
  display: block;
  width: 280px;
  margin: 0 auto 1.2rem auto;
  height: 60px;
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: none;
  border-radius: 12px;
  text-align: center;
}
/* 💄 Mejora visual del campo de correo en compra directa */
.card-compra-directa input[type="email"] {
  width: 100%;
  height: 52px;
  font-size: 1.05rem;
  border-radius: 10px;
  border: 1px solid var(--q-border);
  padding: 10px 14px;
  background-color: var(--q-hover);
}
/* Aumenta la separación entre correo y teléfono */
.card-compra-directa .mb-4.text-start {
  margin-bottom: 3rem !important;
}

/* Mantiene coherencia de espaciado con el bloque del teléfono */
.card-compra-directa .vue-tel-input {
  height: 52px !important;
  border-radius: 12px !important;
  font-size: 1.05rem !important;
}

/* Ajuste fino del subtítulo para alineación */
.card-compra-directa .subtitulo-compra {
  margin-bottom: 2.2rem !important;
}
.form-check-input:checked {
  background-color: var(--q-gold);
  border-color: var(--q-gold);
}

button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ✅ Corrige el estilo del checkbox */
.card-compra-directa .form-check-input {
  width: 1.2em !important;
  height: 1.2em !important;
  margin-top: 0.25em;
  margin-right: 0.5em;
  border-radius: 4px;
  border: 1px solid var(--q-border-md);
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  background-color: var(--q-card) !important;
}

/* Ajusta el label para alinearlo bien */
.card-compra-directa .form-check-label {
  font-size: 0.95rem;
  color: var(--q-text);
  line-height: 1.4;
}
.card-exito {
  background: var(--q-card);
  border-radius: 20px;
  border: 1px solid var(--q-border);
}

.titulo-exito {
  font-size: 1.8rem;
  color: var(--q-green);
}

.subtitulo-exito {
  font-size: 1.1rem;
  color: var(--q-muted);
}

.enlace-pronostico {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--q-gold);
  text-decoration: underline;
  word-break: break-all;
  display: block;
  margin-top: 1rem;
}
.agradecimiento-final {
  font-size: 1.15rem;
  color: var(--q-text);
  line-height: 1.65;
  text-align: center;
  background: var(--q-card-alt);
  padding: 1.6rem 1.2rem;
  border-radius: 16px;
  border: 1px solid var(--q-border);
  margin-top: 2.3rem;
  font-family: var(--q-font-ui);
  box-shadow: 0 4px 14px rgba(0,0,0,0.06);
}
.precio-pago {
  font-size: 1.2rem;
}

.precio-pago span {
  display: inline-block;
}
input[disabled] {
  background-color: var(--q-hover) !important;
  cursor: not-allowed;
}
/* -------------------------------------------------- */
/* 📱 RESPONSIVE QUANTY */
/* -------------------------------------------------- */

/* 📌 Ajuste general para móviles */
@media (max-width: 768px) {

  /* Evita que se aplaste todo por el 88vh */
  .compra-pronostico {
    align-items: flex-start !important;  /* ✅ no centrar vertical */
    min-height: auto !important;
    height: auto !important;
    padding: 1.5rem 0 8rem !important;  /* ✅ aire extra abajo */
  }

  .compra-pronostico h1 {
    font-size: 1.7rem !important;
    line-height: 2.2rem !important;
    margin-bottom: 0.8rem;
  }

  .compra-pronostico p {
    font-size: 1rem !important;
  }

  .nombre-tipster {
    font-size: 1.2rem !important;
  }

  /* 🏷️ Código descuento: input + botón en vertical */
  .input-group {
    flex-direction: column !important;
    width: 100% !important;
  }

  .input-group input {
    width: 100% !important;
    margin-bottom: 8px;
  }

  .input-group button {
    width: 100% !important;
    height: 48px;
  }

  /* 💳 Stripe */
  .stripe-container {
    padding: 1.2rem !important;
    border-radius: 12px !important;
  }

  /* Evita overflow de iframe interno */
  .stripe-container iframe {
    width: 100% !important;
  }

  .precio-pago {
    font-size: 1.05rem !important;
    margin-top: 1rem;
    margin-bottom: 1.2rem;
  }

  /* 🧾 Compra directa */
  .card-compra-directa {
    padding: 1.6rem !important;
  }

  .card-compra-directa input[type="email"],
  .vue-tel-input {
    height: 48px !important;
    font-size: 1rem !important;
  }

  /* 🎛️ Botones principales */
  .btn-pronostico,
  .btn-tipster,
  .btn-opcion {
    width: 100% !important;
    height: 50px !important;
    font-size: 1rem !important;
  }

  /* 🎉 Pantalla final */
  .card-exito {
    padding: 1.8rem !important;
  }

  .titulo-exito {
    font-size: 1.5rem !important;
  }

  .enlace-pronostico {
    font-size: 1rem !important;
  }

  /* 🔚 Evitar scroll lateral */
  body,
  html {
    overflow-x: hidden !important;
  }
}

/* -------------------------------------------------- */
/* 📟 Tablet (768px a 1024px) */
/* -------------------------------------------------- */

@media (min-width: 769px) and (max-width: 1024px) {

  .compra-pronostico {
    padding-top: 2rem !important;
  }

  .input-group {
    gap: 8px;
  }

  .btn-pronostico {
    width: 80% !important;
  }

  .stripe-container {
    padding: 1.8rem !important;
  }
}

.cabecera-pronostico{
  width: 100%;
  max-width: 520px;
  margin: 0 auto 0.75rem auto;
  padding: 0 16px;            /* aire en móviles */
  text-align: center;
}

.titulo-pronostico{
  margin: 0;
  text-align: center;
  line-height: 1.15;
  white-space: normal !important;     /* ✅ que pueda saltar línea */
  overflow-wrap: anywhere;            /* ✅ no se corta */
  word-break: break-word;
}

.subtitulo-pronostico{
  margin: 0.35rem 0 0;
  text-align: center;
}

/* Descripción del producto */
.prod-desc {
  margin: 14px auto 0;
  max-width: 400px;
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.65;
  text-align: center;
  letter-spacing: 0.01em;

  /* Gradient shimmer */
  background: linear-gradient(
    90deg,
    #c97a10 0%,
    #f5a623 25%,
    #ffe48a 50%,
    #f5a623 75%,
    #c97a10 100%
  );
  background-size: 250% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: desc-shimmer 3.5s linear infinite;

  /* Glow suave */
  filter: drop-shadow(0 0 8px rgba(245, 166, 35, 0.35));
}
@keyframes desc-shimmer {
  0%   { background-position: 200% center; }
  100% { background-position: -200% center; }
}
.prod-desc :deep(p),
.prod-desc :deep(div) { margin: 0; }
.prod-desc :deep(strong) { font-weight: 800; }
.prod-desc :deep(em)     { font-style: italic; }
/* =========================
   EXPIRADO (NOK) - Empirulado
========================= */
.expirado-wrap{
  min-height: calc(100vh - 240px); /* deja espacio para header/footer */
  display:flex;
  align-items:center;
  justify-content:center;
  padding: 2.5rem 1rem 7rem;
}

.expirado-card{
  width: 100%;
  max-width: 560px;
  background: var(--q-card);
  border: 2px solid rgba(220,53,69,0.55);
  border-left: 10px solid var(--q-red);
  border-radius: 18px;
  box-shadow: 0 18px 55px rgba(0,0,0,0.18);
  padding: 2.2rem 1.8rem;
  text-align: center;
}

.expirado-icon{
  width: 62px;
  height: 62px;
  margin: 0 auto 0.8rem;
  border-radius: 16px;
  display:flex;
  align-items:center;
  justify-content:center;
  background: rgba(220,53,69,0.12);
  font-size: 1.9rem;
}

.expirado-title{
  margin: 0 0 0.6rem 0;
  font-weight: 900;
  color: var(--q-red);
  letter-spacing: 0.2px;
}

.expirado-msg{
  margin: 0 auto 1.4rem;
  max-width: 460px;
  color: var(--q-muted);
  font-size: 1.05rem;
  line-height: 1.55;
}

.expirado-actions{
  display:flex;
  gap: 12px;
  justify-content:center;
  flex-wrap: wrap;
  margin-bottom: 1.1rem;
}

.expirado-btn{
  height: 46px;
  min-width: 170px;
  border: none;
  border-radius: 12px;
  background: var(--q-red);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
  transition: transform .12s ease, filter .12s ease;
}
.expirado-btn:hover{ transform: translateY(-1px); filter: brightness(1.03); }
.expirado-btn:active{ transform: translateY(0px); }

.expirado-btn.secundario{
  background: var(--q-gold); /* azul Quanty → gold */
}

.expirado-foot{
  margin: 0;
  font-size: 0.92rem;
  color: var(--q-muted);
}

@media (max-width: 480px){
  .expirado-card{ padding: 1.8rem 1.3rem; }
  .expirado-btn{ width: 100%; min-width: 0; }
}

/* =========================
   Quanty Skin (solo Pronostico - Compra Directa)
   Aplica a inputs y selects bootstrap dentro de la card
========================= */
.card-compra-directa .form-control,
.card-compra-directa .form-select{
  background-color: var(--q-hover);
  border-color: var(--q-border);
  border-radius:10px;
}

/* Focus empirulado */
.card-compra-directa .form-control:focus,
.card-compra-directa .form-select:focus{
  border-color: var(--q-gold);
  box-shadow:0 0 0 3px rgba(245,166,35,0.2);
  outline:none;
}
.card-compra-directa .form-control:disabled,
.card-compra-directa .form-select:disabled{
  background-color: var(--q-hover);
  cursor:not-allowed;
  opacity:0.9;
}
/* =========================
   Cupón: input + botón coherentes (sin esquinas raras)
========================= */
.compra-pronostico .input-group .form-control{
  border-top-right-radius:10px !important;
  border-bottom-right-radius:10px !important;
}

.compra-pronostico .input-group .btn{
  border-top-left-radius:10px !important;
  border-bottom-left-radius:10px !important;
  border-top-right-radius:10px !important;
  border-bottom-right-radius:10px !important;
}
/* Desktop/tablet: input + botón perfectamente alineados */
.compra-pronostico .input-group{
  align-items: stretch;            /* mismo alto */
}

.compra-pronostico .input-group .form-control{
  height: 52px;                    /* igual que compra directa */
}

.compra-pronostico .input-group .btn{
  height: 52px;                    /* igual que input */
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
/* =========================
   Cupón: apilar SIEMPRE (desktop + móvil)
========================= */
.compra-pronostico .input-group-cupon{
  display:flex;
  flex-direction:column !important;
  gap:8px;
}

.compra-pronostico .input-group-cupon .form-control{
  width:100% !important;
}

.compra-pronostico .input-group-cupon .q-btn{
  width:100% !important;
  height:52px;
  border-radius: 8px !important;
}
.contador-expira{
  font-weight:800;
  font-size: 0.98rem;
  color: var(--q-red);
  background: rgba(220,53,69,0.10);
  border: 1px solid rgba(220,53,69,0.25);
  display:inline-block;
  padding: 6px 12px;
  border-radius: 999px;
}
.moneda-row{
  display:flex;
  gap:10px;
  align-items:center;
  justify-content:center;
  max-width: 420px;
  margin: 0 auto;
}

.moneda-select{
  width: 160px;
  height: 44px;
  border-radius: 12px;
  background: var(--q-hover);
  border:1px solid var(--q-border);
}
.moneda-pills{
  display:flex;
  gap:8px;
  flex-wrap: wrap;
  justify-content:center;
}

.moneda-pill{
  border: 1px solid var(--q-border);
  background: var(--q-hover);
  color: var(--q-text);
  font-weight: 800;
  font-size: 0.92rem;
  padding: 8px 12px;
  border-radius: 999px;
  cursor: pointer;
  transition: transform .12s ease, filter .12s ease, box-shadow .12s ease, border-color .12s ease;
}

.moneda-pill:hover{
  transform: translateY(-1px);
  filter: brightness(1.02);
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

.moneda-pill.active{
  background: var(--q-gold);
  border-color: var(--q-gold);
  color: var(--q-gold-on);
  box-shadow: 0 8px 22px rgba(245,166,35,0.22);
}

@media (max-width: 420px){
  .moneda-pill{
    font-size: 0.9rem;
    padding: 7px 10px;
  }
}
.lang-top-wrap{
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.9rem 0 0.1rem;
}

.lang-top-switcher{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

.lang-flag{
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font-size: 1.7rem;
  line-height: 1;
  cursor: pointer;
  transition: transform .15s ease, opacity .15s ease, filter .15s ease;
  opacity: 0.72;
}

.lang-flag:hover{
  transform: scale(1.08);
  opacity: 1;
}

.lang-flag.active{
  opacity: 1;
  transform: scale(1.12);
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.18));
}

.lang-flag:focus{
  outline: none;
}

@media (max-width: 480px){
  .lang-top-wrap{
    padding: 0.8rem 0 0;
  }

  .lang-top-switcher{
    gap: 16px;
  }

  .lang-flag{
    font-size: 1.55rem;
  }
}

/* Bloque "suscripción requiere cuenta" */
.suscripcion-requiere-cuenta {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 360px;
  margin: 3rem auto 0;
  padding: 2rem 1.5rem;
  background: var(--q-card-alt, rgba(255,255,255,0.04));
  border: 1px solid var(--q-border);
  border-radius: 16px;
}

.src-icono {
  font-size: 2.2rem;
  margin-bottom: 0.75rem;
}

.src-titulo {
  font-size: 1rem;
  font-weight: 700;
  color: var(--q-text);
  margin-bottom: 0.5rem;
}

.src-desc {
  font-size: 0.88rem;
  color: var(--q-muted);
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.src-btn {
  width: 100%;
  padding: 11px 0;
  font-size: 0.9rem;
  font-weight: 700;
  border-radius: 8px;
}

.src-btn + .src-btn {
  margin-top: 10px;
}

.btn-gold {
  background: var(--q-gold) !important;
  color: var(--q-gold-on, #0e203d) !important;
  border-color: var(--q-gold) !important;
}

.src-btn--outline {
  color: var(--q-text) !important;
}
</style>
